import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user:  window.localStorage.getItem('user' || '[]') == null ? '' : window.localStorage.getItem('user' || '[]'),
    access_token:  window.localStorage.getItem('access_token' || '[]') == null ? '' : window.localStorage.getItem('access_token' || '[]')
  },
  mutations: {
    login (state, user) {
      state.user = user
      state.access_token = user.access_token
      window.localStorage.setItem('user', JSON.stringify(user))
      window.localStorage.setItem('access_token', user.access_token)
    },
    logout (state) {
      state.user = []
      state.access_token = undefined
      window.localStorage.removeItem('access_token')
      window.localStorage.removeItem('user')
    }

  }
})



// WEBPACK FOOTER //
// ./src/store/index.js